<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box">
      <div class="search-left">
        <div>
          <span>项目名称:</span>
          <el-input
            class="search-input"
            placeholder="项目名称"
            v-model="searchQuery.projectName"
            clearable
          />
        </div>
        <div>
          <span>任务月度:</span>
          <el-date-picker
            @change="dateChange"
            range-separator="-"
            value-format="yyyy-MM"
            type="month"
            v-model="dateValue"
          />
        </div>
        <div v-if="searchQuery.projectStructureType == 1">
          <span>支付截止时间:</span>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="searchQuery.orderEndPayDt"
          />
        </div>
        <div>
          <span>订单编号:</span>
          <el-input
            class="search-input"
            placeholder="订单编号"
            v-model="searchQuery.orderNo"
            clearable
          />
        </div>
        <div>
          <span>支付状态:</span>
          <el-select
            v-model="searchQuery.payStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in projectOrderPayStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">查询</el-button>
        <el-button
          type="primary"
          style="background:#EB8E0E;border:1px solid #EB8E0E;"
          @click="showComponent('fenqiPay', {})"
        >
          合并支付
        </el-button>
      </div>
    </div>
    <!--列表-->
    <div class>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="true"
        header-row-class-name="noBorder"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="序号"
          type="index"
          width="50"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orderNo"
          type="expand"
        >
          <template slot-scope="{ row }">
            <div class="expandBox">
              <p>项目订单</p>
              <div class="orderNo">
                <p>订单编号：</p>
                <p>{{ row.orderNo }}</p>
              </div>
              <div class="orderNo">
                <p>项目金额：</p>
                <div style="display:flex;align-items:center;">
                  <span style="margin-right:10px;">
                    {{ (row.projectPrice - row.discountPrice) | moneyFixed }}
                  </span>
                  <el-button
                    primary
                    type="text"
                    style="padding:0;"
                    @click="showComponent('payDetail', row)"
                  >
                    详情
                  </el-button>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    v-if="
                      searchQuery.projectStructureType == 1 && row.discountPrice
                    "
                  >
                    <div>
                      应付：{{
                        (row.initOrderPrice - row.platformServicesPrice)
                          | moneyFixed
                      }}
                    </div>
                    <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
                    <div>
                      实付：{{
                        (row.orderPrice - row.platformServicesPrice)
                          | moneyFixed
                      }}
                    </div>
                    <img
                      src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                      slot="reference"
                      class="info"
                    />
                  </el-popover>
                </div>
              </div>
              <div>
                <p>支付状态：</p>
                <p>{{ row.csoPayStatus | transCsoStatus }}</p>
              </div>
              <div class="orderNo">
                <p>支付时间：</p>
                <p>{{ row.orderPayDt | transAllTime }}</p>
              </div>
              <el-button
                primary
                type="text"
                @click="showComponent('confirmPay', row, 3)"
                :disabled="judgeService(row)"
              >
                {{ handleCso(row.csoPayStatus) }}
              </el-button>
            </div>
            <div class="expandBox">
              <p>平台服务费订单</p>
              <div class="orderNo">
                <p>订单编号：</p>
                <p>{{ row.serviceOrderNo }}</p>
              </div>
              <div class="orderNo">
                <p>平台服务费：</p>
                <div style="display:flex;align-items:center;">
                  <span style="margin-right:10px;">
                    {{ row.platformServicesPrice | moneyFixed }}
                  </span>
                  <el-button
                    primary
                    type="text"
                    style="padding:0;"
                    @click="showComponent('serviceDetail', row)"
                  >
                    详情
                  </el-button>
                </div>
              </div>
              <div>
                <p>支付状态：</p>
                <p>{{ row.servicesPricePayStatus | serviceStatus }}</p>
              </div>
              <div class="orderNo">
                <p>支付时间：</p>
                <p>{{ row.servicePayDt | transAllTime }}</p>
              </div>
              <el-button
                primary
                type="text"
                @click="showComponent('servicePay', row)"
              >
                {{ searvicePayHandler(row.servicesPricePayStatus) }}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="任务月度"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="订单生成时间"
          v-if="searchQuery.projectStructureType == 1"
          key="taskDt"
        >
          <template slot-scope="{ row }">
            {{ row.createDt | transDate }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="支付截止时间"
          v-if="searchQuery.projectStructureType == 1"
          key="orderEndPayDt"
          width="180"
        >
          <template slot-scope="{ row }">
            {{ row.orderEndPayDt | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="本次需打款总金额"
          width="140"
        >
          <template slot-scope="{ row }">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ row.orderPrice | moneyFixed }}</span>
              <el-popover
                placement="top-start"
                trigger="hover"
                v-if="
                  searchQuery.projectStructureType == 1 && row.discountPrice
                "
              >
                <div>应付：{{ row.initOrderPrice | moneyFixed }}</div>
                <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
                <div>实付：{{ row.orderPrice | moneyFixed }}</div>
                <img
                  src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                  slot="reference"
                  class="info"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="payStatus"
          label="支付状态"
        >
          <template slot-scope="{ row }">
            <span>{{ row.payStatus | payStatusFil }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="showComponent('confirmPay', row, 1)"
              :disabled="judgeService(row)"
            >
              {{ payStatusHandlerName(row.payStatus) }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <component
      :is="componentName"
      :show-dialog="showDetail"
      :type="type"
    ></component>
  </div>
</template>

<script>
import payDetail from './payDetail.vue';
import qualifyDetail from './qualifyDetail.vue';
import serviceDetail from './serviceDetail.vue';
import confirmPay from './confirmPay.vue';
import sanjiConfirmPay from './sanjiConfirmPay.vue';
import getiDetail from './getiDetail.vue';
import gerenDetail from './gerenDetail.vue';
import fenqiPay from './fenqiPay.vue';
import confirmFenqiPay from './confirmFenqiPay.vue';
import { projectOrderList } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect';
import datePicker from '@/Mixin/datePicker';
import { projectOrderPayStatus } from '@/config/staticData';
import sanji from '@/Mixin/sanji';
import dingdanFillProjectName from '@/Mixin/dingdanFillProjectName';
export default {
  mixins: [pageInation, makeSure, datePicker, sanji, dingdanFillProjectName],
  props: {
    chooseType: {
      type: Number
    }
  },
  data() {
    return {
      noNeedForDate: this.$route.taskDt ? true : false,
      projectOrderPayStatus,
      ruleForm: {
        taskDate: ''
      }, // 用户信息
      getList: projectOrderList, // 获取列表的AJAX
      searchQuery: {
        hasPay: 0,
        projectName: this.$route.query.projectName || '',
        orderNo: '',
        payStatus: '',
        taskDt: this.$route.query.taskDt || '',
        projectStructureType: ''
      },
      showDetail: false,
      componentName: '',
      type: '',
      // 下发当前选中的item
      item: {
        data: null,
        payList: []
      }
    };
  },
  components: {
    dicSelect,
    payDetail,
    qualifyDetail,
    serviceDetail,
    confirmPay,
    getiDetail,
    gerenDetail,
    sanjiConfirmPay,
    fenqiPay,
    confirmFenqiPay
  },
  provide() {
    return {
      itemData: this.item
    };
  },
  computed: {},
  methods: {
    // 支付状态对应操作
    // 1: '待支付',
    // 2: '审核中',
    // 3: '审核未通过',
    // 4: '部分支付成功'
    payStatusHandlerName(payStatus) {
      if ([1, 3].includes(payStatus)) {
        return '支付';
      } else if (payStatus === 4) {
        return '继续支付';
      } else {
        return '详情';
      }
    },
    searvicePayHandler(payStatus) {
      if (payStatus == 0) {
        return '支付';
      } else if (payStatus == 3) {
        return '重新支付';
      } else {
        return '详情';
      }
    },
    judgeService(row) {
      if (
        row.servicesPricePayStatus == 1 &&
        [0, 3].includes(row.csoPayStatus)
      ) {
        return true;
      } else {
        return false;
      }
    },
    handleCso(v) {
      let s = {
        0: '支付',
        1: '详情',
        2: '详情',
        3: '重新支付'
      };
      return s[v];
    },
    showComponent(componentName, item = null, type = null) {
      item.projectStructureType = this.searchQuery.projectStructureType;
      this.item.data = item;
      if (componentName == 'payDetail') {
        if (this.searchQuery.projectStructureType == 1) {
          //四级
          this.componentName = 'payDetail';
        } else if (this.searchQuery.projectStructureType == 2) {
          //三级个体
          this.componentName = 'getiDetail';
        } else {
          //三级个人
          this.componentName = 'gerenDetail';
        }
      } else if (componentName == 'confirmPay') {
        //点击支付
        this.type = type;
        if (![1, 3, 4].includes(item.payStatus)) {
          //如果订单状态已支付就去查看详情
          this.componentName =
            this.searchQuery.projectStructureType > 1
              ? 'sanjiConfirmPay'
              : 'confirmPay';
        } else if ([0, 3].includes(item.servicesPricePayStatus)) {
          //如果服务费未支付
          this.componentName = 'fenqiPay';
        } else {
          //服务费已支付，订单未支付
          this.componentName =
            this.searchQuery.projectStructureType > 1
              ? 'sanjiConfirmPay'
              : 'confirmPay';
        }
      } else if (componentName == 'servicePay') {
        //服务费处支付
        this.type = 2;
        this.componentName =
          this.searchQuery.projectStructureType > 1
            ? 'sanjiConfirmPay'
            : 'confirmPay';
      } else {
        //其他
        this.componentName = componentName;
      }
      localStorage.setItem('activeTask', JSON.stringify(item));
      this.showDetail = true;
    },
    dealThreeFlex() {
      if (/threeFlex/.test(this.$route.path)) {
        if (this.chooseType === 1) {
          this.searchQuery.projectStructureType = 3;
          this.searchQuery.patternType = 7;
          this.isIndustry = true;
          this.isP = false;
        } else if (this.chooseType === 2) {
          this.searchQuery.projectStructureType = 1;
          this.searchQuery.patternType = 8;
          this.isIndustry = false;
          this.isP = true;
        }
      }
    }
  },
  created() {
    this.dealThreeFlex();
  },
  watch: {
    chooseType: {
      handler() {
        this.dealThreeFlex();
        this.initWatchRouteChange();
      }
    }
  },
  filters: {
    payStatusFil(v) {
      let s = {
        1: '待支付',
        2: '支付中',
        3: '支付失败',
        4: '部分支付成功',
        5: '支付中',
        6: '支付失败'
      };
      return s[v];
    },
    serviceStatus(v) {
      let s = {
        0: '待支付',
        1: '支付中',
        2: '支付成功',
        3: '支付失败'
      };
      return s[v];
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  width: 14px;
  height: 14px;
  margin-top: -4px;
}
</style>
<style lang="scss">
.expandBox {
  display: flex;
  align-items: center;
  > * {
    flex: 1;
  }
  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .orderNo {
    flex: 2;
  }
  > p {
    font-weight: bold;
    width: 120px;
  }
}
.expandBox:first-of-type {
  margin-bottom: 20px;
}
.noBorder th {
  border: none !important;
}
</style>
